<div class="table-fms">
  <table>
    <thead>
    <tr>
      <th colspan="2"></th>
      <th class="blank-space"></th>
      <th colspan="4">TVPI</th>
      <th class="blank-space"></th>
      <th colspan="4">Net IRR</th>
      <th class="blank-space"></th>
      <th colspan="4">MOIC</th>
      <th class="blank-space"></th>
      <th colspan="4">Portfolio IRR</th>
      <th class="blank-space"></th>
      <th colspan="3">Contribution</th>
    </tr>
    <tr>
      <th class="fix-w-2">
        <app-three-dots-menu [matMenuTriggerFor]="menu"></app-three-dots-menu>
            <mat-menu #menu="matMenu">
              <ul class="list">
                <app-drop-down-item class="width-100pcnt"
                  data-qa="excel"
                  [text]="'Export'"
                  [iconNameAndStyling]="'excel.svg'"
                  (click)="exportExcel()">
                </app-drop-down-item>
              </ul>
            </mat-menu>
      </th>
      <th class="fix-w-3p5">Vintage</th>
      <th class="blank-space"></th>

      <th class="fix-w-3p5">Bottom 25%</th>
      <th class="fix-w-3p5">Median</th>
      <th class="fix-w-3p5">Top 25%</th>
      <th class="fix-w-3p5">Fund</th>
      <th class="blank-space"></th>

      <th class="fix-w-3p5">Bottom 25%</th>
      <th class="fix-w-3p5">Median</th>
      <th class="fix-w-3p5">Top 25%</th>
      <th class="fix-w-3p5">Fund</th>
      <th class="blank-space"></th>

      <th class="fix-w-3p5">Bottom 25%</th>
      <th class="fix-w-3p5">Median</th>
      <th class="fix-w-3p5">Top 25%</th>
      <th class="fix-w-3p5">Fund</th>
      <th class="blank-space"></th>

      <th class="fix-w-3p5">Bottom 25%</th>
      <th class="fix-w-3p5">Median</th>
      <th class="fix-w-3p5">Top 25%</th>
      <th class="fix-w-3p5">Fund</th>
      <th class="blank-space"></th>

      <th class="fix-w-3p5">Called</th>
      <th class="fix-w-3p5">Unfunded</th>
      <th>Fund</th>
    </tr>
    </thead>
    <tbody>
    <tr *ngFor="let i of marketData.tvpiChartData.periodsArr; let index = index"
        [ngClass]="{'bg-main-1': selectedFundRow === index}">
      <td class="fix-w-2"></td>
      <td [ngClass]="{'bold600': selectedFundRow === index}" class="fix-w-3p5">{{ marketData.tvpiChartData.periodsArr[index]}}</td>
      <td class="blank-space"></td>

      <!-- TVPI Section -->
      <td class="fix-w-3p5">{{ marketData.tvpiChartData.bottomArr[index] | switcherDashBraces:1:2: false:'x'}}</td>
      <td class="fix-w-3p5">{{ marketData.tvpiChartData.medianArr[index] | switcherDashBraces:1:2: false:'x'}}</td>
      <td class="fix-w-3p5">{{ marketData.tvpiChartData.topArr[index] | switcherDashBraces:1:2: false:'x'}}</td>
      <td class="fix-w-3p5"
        [ngClass]="marketData.tvpiChartData.selectedFundArr[index] ? 'main-8 bold600' : ''">
        {{ marketData.tvpiChartData.selectedFundArr[index] | switcherDashBraces:1:2: false:'x'}}
      </td>
      <td class="blank-space"></td>

      <!-- Net IRR Section -->
      <td class="fix-w-3p5">{{ marketData.netIrrChartData.bottomArr[index] | switcherDashBraces : 1 : 2: false : '' : '%'}}</td>
      <td class="fix-w-3p5">{{ marketData.netIrrChartData.medianArr[index] | switcherDashBraces : 1 : 2: false : '' : '%'}}</td>
      <td class="fix-w-3p5">{{ marketData.netIrrChartData.topArr[index] | switcherDashBraces : 1 : 2: false : '' : '%'}}</td>
      <td class="fix-w-3p5"
          [ngClass]="marketData.netIrrChartData.selectedFundArr[index] ? 'main-8 bold600' : ''">
          {{ marketData.netIrrChartData.selectedFundArr[index] | switcherDashBraces : 1 : 2: false : '' : '%'}}
      </td>
      <td class="blank-space"></td>

      <!-- MOIC Section -->
      <td class="fix-w-3p5">{{ marketData.moicChartData.bottomArr[index] | switcherDashBraces:1:2: false:'x'}}</td>
      <td class="fix-w-3p5">{{ marketData.moicChartData.medianArr[index] | switcherDashBraces:1:2: false:'x'}}</td>
      <td class="fix-w-3p5">{{ marketData.moicChartData.topArr[index] | switcherDashBraces:1:2: false:'x'}}</td>
      <td class="fix-w-3p5"
          [ngClass]="marketData.moicChartData.selectedFundArr[index] ? 'main-8 bold600' : ''">
          {{ marketData.moicChartData.selectedFundArr[index] | switcherDashBraces:1:2: false:'x'}}
      </td>
      <td class="blank-space"></td>

      <!-- Portfolio IRR Section (From Gross IRR) -->
      <td class="fix-w-3p5">{{ marketData.grossIrrChartData.bottomArr[index] | switcherDashBraces : 1 : 2: false : '' : '%'}}</td>
      <td class="fix-w-3p5">{{ marketData.grossIrrChartData.medianArr[index] | switcherDashBraces : 1 : 2: false : '' : '%'}}</td>
      <td class="fix-w-3p5">{{ marketData.grossIrrChartData.topArr[index] | switcherDashBraces : 1 : 2: false : '' : '%'}}</td>
      <td class="fix-w-3p5"
          [ngClass]="marketData.grossIrrChartData.selectedFundArr[index] ? 'main-8 bold600' : ''">
          {{ marketData.grossIrrChartData.selectedFundArr[index] | switcherDashBraces : 1 : 2: false : '' : '%'}}
      </td>
      <td class="blank-space"></td>

      <!-- Contribution Section -->
      <td class="fix-w-3p5">{{ marketData.contributionChartData.averageContribution[index] | switcherDashBraces : 1 : 2: false : '' : '%'}}</td>
      <td class="fix-w-3p5">{{ marketData.contributionChartData.restArr[index] | switcherDashBraces : 1 : 2: false : '' : '%'}}</td>
      <td [ngClass]="marketData.contributionChartData.selectedFundArr[index] ? 'main-8 bold600' : ''">
          {{ marketData.contributionChartData.selectedFundArr[index] | switcherDashBraces : 1 : 2: false : '' : '%'}}
      </td>
    </tr>
    </tbody>
  </table>
</div>
